export enum AccessType {
    HasAccess = 'HasAccess',
    NoAccess = 'NoAccess',
    Both = 'Both',
    HasAccessWithoutHiddenConsideration = 'HasAccessWithoutHiddenConsideration',
    BothForCatalog = 'BothForCatalog',
    All = 'All',
}
